import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const UploadMarketFacilityFormFileRequestDtoSchema = z.object({
  file: z
    .instanceof(File)
    .refine((file) => file.size > 0, 'File is required')
    .refine(
      (file) =>
        [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
        ].includes(file.type),
      'Only Excel files are allowed (.xlsx, .xls)'
    ),
});

const UploadMarketFacilityFormFileResponseDtoSchema = z.object({
  message: z.string(),
});

export type UploadMarketFacilityFormFileRequestDto = FormData;
export type UploadMarketFacilityFormFileResponseDto = z.infer<
  typeof UploadMarketFacilityFormFileResponseDtoSchema
>;

export const uploadMarketFacilityFormFile = (
  dto: UploadMarketFacilityFormFileRequestDto,
  config?: AxiosRequestConfig
) => {
  return api
    .post('/market-facilities/form/upload', dto, config)
    .then(responseContract(UploadMarketFacilityFormFileResponseDtoSchema));
};
